import { render, staticRenderFns } from "./StatisticReportTable.vue?vue&type=template&id=414c7b37&"
import script from "./StatisticReportTable.vue?vue&type=script&lang=js&"
export * from "./StatisticReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports